export class PhoneNumbersToBePortedRange {
  id: number;
  connectionType: string;
  totalCount: number;
  offeredCount: string;
  range: string;
  costMonthly: number;
  costMonthlyEdit: boolean;
  costUnique: number;
  costUniqueEdit: boolean;

  constructor() {
    this.connectionType = 'Single number';
    this.totalCount = 1;
    this.range = '';
    this.offeredCount = '1';
    this.costMonthly = 500;
    this.costMonthlyEdit = false;
    this.costUnique = 3900;
    this.costUniqueEdit = false;

  }


}



// WEBPACK FOOTER //
// ./src/models/phoneNumbersToBePortedRange.ts